
import {assignTicket} from "../../services/Supervisor/ticketService";
import {useState} from "react";

export const useAssignTicket = () => {

    const [assigningTechnician, setAssigningTechnician] = useState(false)

    const assignTicketToTechnician = async (username: string, ticketUniqueCode: string) => {
        setAssigningTechnician(true)
        try {
            await assignTicket(username, ticketUniqueCode)
        } catch (error) {
            console.error('Error fetching filters:', error);
        } finally {
            setTimeout(() => setAssigningTechnician(false), 600)
        }
    }

    return { assignTicketToTechnician, assigningTechnician };
};
